import { types } from "../types/types";

const initialState = {
  loading: false,
  loadingRecord: false,
  defs: [],
  recordChecklist: { items: [], canAdvance: true, enabled: false }
};

export const flowChecklistReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FLOW_CHECKLIST_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.FLOW_CHECKLIST_SET_DEFS:
      return { ...state, defs: action.payload };
    case types.FLOW_CHECKLIST_SET_RECORD:
      return { ...state, recordChecklist: action.payload };
    default:
      return state;
  }
};
